module.exports = __webpack_public_path__ + "static/img/7areaA_07.2b10516.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/7areaA_07.png
// module id = 920
// module chunks = 1